import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal, ModalDismissReasons, NgbCalendar, NgbDate, NgbDateAdapter, NgbModalOptions, NgbActiveModal, NgbDateStruct, NgbDateParserFormatter, NgbDateNativeAdapter, NgbDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { Meeting } from 'src/app/model/meeting.model';
import { DateService } from 'src/app/services/date.service';
import { DatePipe } from '@angular/common';
import { AppConstant } from 'src/app/config/app.constant';
import { concatMap } from 'rxjs/operators';
import { log } from 'console';
import { MeetingService } from 'src/app/services/meeting.service';
import { EmployeeService } from 'src/app/_Core/_Services/employee.service';

@Component({
  standalone: false,
  selector: 'app-cancel-meetingroom-booking',
  templateUrl: './cancel-meetingroom-booking.component.html',
  styleUrls: ['./cancel-meetingroom-booking.component.scss'],
})
export class CancelMeetingroomBooking implements OnInit {
  @Input() id: string;
  @Input() meetingRoomId: string;

  constructor(
    public modal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private router: Router,
    public datepipe: DatePipe,
    private dateSrv: DateService,
    private calendar: NgbCalendar,
    public formatter: NgbDateParserFormatter,
    private meetingService: MeetingService,
    private employeeService: EmployeeService,
  ) {
  }

  ngOnInit(): void { }

  cancelBooking() {
    const payload = {
      bookingId: this.meetingRoomId
    };
    this.employeeService.cancelBlockedMeetingRoom(this.meetingRoomId).subscribe((res) => {
      this.modal.close();
      // this.modal.dismiss();
      location.reload();
      setTimeout(() => {
        location.reload();
      }, 10000);
    });
  }
}
